module.exports = __webpack_public_path__ + "img/landlordImg.dc956f11.svg";